import { api } from "@/lib/axios";

export type WorkspaceKey = string;
export type WorkspaceAccessMode = "unrestricted" | "restricted" | "disabled";
export type WorkspaceAccessRole = "OWNER" | "ADMIN" | "EDITOR" | "VIEWER";

export interface WorkspaceAccessRule {
  mode: WorkspaceAccessMode;
  allowed_roles: WorkspaceAccessRole[];
  allowed_user_ids: number[];
  denied_roles: WorkspaceAccessRole[];
  denied_user_ids: number[];
}

export interface WorkspaceAccessRoleOption {
  value: WorkspaceAccessRole;
  label: string;
}

export interface WorkspaceAccessProjectMember {
  id: number;
  email: string;
  name: string;
  role: WorkspaceAccessRole;
}

export interface WorkspaceAccessPayload {
  project: { id: number; name: string };
  workspace_keys: WorkspaceKey[];
  access: Record<WorkspaceKey, boolean>;
  can_manage: boolean;
  can_edit?: boolean;
  workspaces: Partial<Record<WorkspaceKey, WorkspaceAccessRule>>;
  available_roles: WorkspaceAccessRoleOption[];
  available_project_members: WorkspaceAccessProjectMember[];
}

export const workspaceAccessQueryKey = (projectId: string | number) =>
  ["workspace-access", String(projectId)] as const;

export async function getWorkspaceAccess(
  projectId: string | number
): Promise<WorkspaceAccessPayload> {
  const response = await api.get(
    `/projects/${projectId}/operations/workspace-access/`
  );
  return response.data;
}

export async function saveWorkspaceAccess(
  projectId: string | number,
  workspaces: Partial<Record<WorkspaceKey, WorkspaceAccessRule>>
): Promise<WorkspaceAccessPayload> {
  const response = await api.patch(
    `/projects/${projectId}/operations/workspace-access/`,
    { workspaces }
  );
  return response.data;
}
